import { render, staticRenderFns } from "./TransactionRefundManagement.vue?vue&type=template&id=b838797e&scoped=true"
import script from "./TransactionRefundManagement.vue?vue&type=script&lang=ts"
export * from "./TransactionRefundManagement.vue?vue&type=script&lang=ts"
import style0 from "./TransactionRefundManagement.vue?vue&type=style&index=0&id=b838797e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b838797e",
  null
  
)

export default component.exports